import script from "./MessageSettingsPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./MessageSettingsPreview.vue?vue&type=script&setup=true&lang=js"

import "./MessageSettingsPreview.vue?vue&type=style&index=0&id=83c1cea8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83c1cea8"]])

export default __exports__